import { TagDef } from '../types';

/**
 * 标签列表
 * 标签类型：positive（正面）/ negative（负面）/ neutral（中性）
 * 属性加成格式：{ attr: 值 }，可省略——加成也可能是机制型/事件型，不含属性数值
 * 没有删除条件 = 永久标签
 */
export const TAGS: TagDef[] = [
    // ===== 正面标签 =====
    {
        id: 'TAG_001',
        name: '科班出身',
        type: 'positive',
        description: '四年科班，台词、形体、声乐一样没落下。老师留了联系方式，同窗散在几个剧组，起步比旁人稳。可越是被说「底子好」，越得拿出点课本以外的东西，不然一句花瓶就能把人打回去。',
        acquireCondition: '开局身份选择',
        priority: 100,
        pool: 'origin',
        unlocked: false,
        // 优势文案已定稿；对应效果（开局演技加成 / 表演训练进度）尚未实现
        perk: '开局演技 +10 · 表演类训练进度 +1',
    },
    {
        id: 'TAG_002',
        name: '天生丽质',
        type: 'positive',
        description: '出众的外貌让你在人群中脱颖而出',
        attributeBonus: { charm: 50 },
        acquireCondition: '开局特性选择',
        priority: 100,
        pool: 'trait',
        perk: '颜值 +50',
        /** 特性点数价（正数＝消耗点数） */
        traitPoints: 1,
    },
    {
        id: 'TAG_003',
        name: '八面玲珑',
        type: 'positive',
        description: '你能在复杂的人际关系中游刃有余',
        attributeBonus: { eq: 50 },
        acquireCondition: '开局特性选择',
        priority: 100,
        pool: 'trait',
        perk: '情商 +50',
        /** 特性点数价（正数＝消耗点数） */
        traitPoints: 1,
    },
    {
        id: 'TAG_004',
        name: '体魄强健',
        type: 'positive',
        description: '你的身体素质和耐力远超常人',
        attributeBonus: { stamina: 50 },
        acquireCondition: '开局特性选择',
        priority: 100,
        pool: 'trait',
        perk: '体能 +50',
        /** 特性点数价（正数＝消耗点数） */
        traitPoints: 1,
    },
    {
        id: 'TAG_005',
        name: '人脉广博',
        type: 'positive',
        description: '你在圈内结识了不少朋友',
        attributeBonus: { eq: 3, reputation: 3 },
        acquireCondition: '社交系统达到一定次数',
        priority: 80,
        perk: '情商 +3 · 口碑 +3',
    },
    {
        id: 'TAG_009',
        name: '气质如兰',
        type: 'positive',
        description: '高雅出众的气质，让你自带光环',
        attributeBonus: { temperament: 50 },
        acquireCondition: '开局特性选择',
        priority: 100,
        pool: 'trait',
        perk: '气质 +50',
        /** 特性点数价（正数＝消耗点数） */
        traitPoints: 1,
    },
    {
        id: 'TAG_011',
        name: '天生戏骨',
        type: 'positive',
        description: '对角色有天然的直觉与共情力',
        attributeBonus: { talent: 50 },
        acquireCondition: '开局特性选择',
        priority: 100,
        pool: 'trait',
        perk: '演技 +50',
        /** 特性点数价（正数＝消耗点数） */
        traitPoints: 1,
    },
    {
        id: 'TAG_012',
        name: '资源咖',
        type: 'positive',
        description: '有人把第一部戏递到你手上。公司肯砸资源，导演愿意给机会，连通稿都写得漂亮。只是旁人点头认得的是你背后的名字，不是你的名字——想摘掉这顶帽子，得先让人记住脸。',
        acquireCondition: '开局身份选择',
        priority: 100,
        pool: 'origin',
        unlocked: false,
        // 优势文案已定稿；对应效果（开局自带大制作 / 片酬加成）尚未实现
        perk: '开局自带一部大制作剧本 · 片酬 +10%',
    },
    {
        id: 'TAG_013',
        name: '富家千金',
        type: 'positive',
        description: '家里有钱，路早就铺好了。签的是自家投资的公司，经纪人不敢怠慢，行程也总挑最舒服的。只是卡随时可能被停——花家里的钱，就得听家里的话，想证明自己不是玩票，反而比谁都难。',
        acquireCondition: '开局身份选择',
        priority: 100,
        pool: 'origin',
        unlocked: false,
        // 优势文案已定稿；其中「启动资金 / 带资进组」为现有 TAG_EFFECTS 效果，文案仅作展示
        perk: '开局自带 ¥200,000 启动资金 · 解锁带资进组',
    },
    {
        id: 'TAG_014',
        name: '素人出道',
        type: 'positive',
        description: '没有背景，只有笨功夫。签的是家小公司，经纪人手底下没几个艺人。没人替你铺路，也没人催你上进——想多学一点，只能自己留下来加练。',
        acquireCondition: '开局身份选择',
        priority: 100,
        pool: 'origin',
        unlocked: true,
        perk: '每月第一次训练，额外 +1 路径进度',
    },
    {
        id: 'TAG_015',
        name: '锦鲤附体',
        type: 'positive',
        description: '关键时刻，运气总站在你这边',
        acquireCondition: '开局特性选择',
        priority: 100,
        pool: 'trait',
        perk: '事件掷骰判定 +1',
        /** 特性点数价（正数＝消耗点数） */
        traitPoints: 1,
    },
    {
        id: 'TAG_016',
        name: '自来熟',
        type: 'positive',
        description: '新认识的人，总愿意先对你多一分好感',
        acquireCondition: '开局特性选择',
        priority: 100,
        pool: 'trait',
        perk: '新结识角色初始好感 +10',
        /** 特性点数价（正数＝消耗点数） */
        traitPoints: 1,
    },
    {
        id: 'TAG_017',
        name: '谈判专家',
        type: 'positive',
        description: '谈片酬时，你总能多要下来一点',
        acquireCondition: '开局特性选择',
        priority: 100,
        pool: 'trait',
        perk: '片酬 +5%',
        /** 特性点数价（正数＝消耗点数） */
        traitPoints: 1,
    },
    {
        id: 'TAG_018',
        name: '奖项复利',
        type: 'positive',
        description: '每一座奖杯，都是下一座奖杯的入场券',
        acquireCondition: '开局特性选择',
        priority: 100,
        pool: 'trait',
        perk: '每多一座奖，获奖名气 +30%（×3 封顶）',
        /**
         * 「**得到过越多奖，奖项加成就越高**」（2026-10-22 用户令）：
         * 倍率 ＝ `min(封顶, 1 + 已得奖数 × 步长)`。
         * **步长 0.3 ＝ 每多一座已得的奖，之后每座奖的名气 +30%**（倍率 **加** 0.3，不是"乘 0.3"）。
         * **封顶 ×3**（2026-10-22 用户令）⇒ 第1座 ×1.3（195）／第2座 ×1.6（240）／第3座 ×1.9（285）／
         * 第4座 ×2.2（330）／第5座 ×2.5（375）／第6座 ×2.8（420）／**第7座起 ×3（450）封顶**，再多的奖也不涨。
         * 已得奖数＝`awardHistory` 里 playerWon 的条数（＝结算页「获奖陈列」那一排奖杯，一个奖种一座），
         * **含本次领奖**（领奖记录先入 history 再发钱）。
         * ⛔ 只乘**获奖**那笔名气（`AWARD_FAME_WIN` 150）：提名频次高，⛔ 不乘（否则变成刷名气的口子）。
         * ⛔ 口碑不乘（定额制）；⛔ 作品滴灌/营销营业/事件行程都不乘。
         */
        awardFameStep: 0.3,
        awardFameCap: 3,
        /** 特性点数价（正数＝消耗点数） */
        traitPoints: 2,
    },


    // ===== 开局负面特性（2026-10-21 特性点数制）=====
    // 机制：正面＝花点数买、负面＝**回点数**（拿代价换预算）。
    // 「训练减半」类：**只砍训练获得的那部分增量**（机制见 `TagDef.halvedAttr` 注释；
    //   ⛔ 2026-10-21 用户令：不砍开局底值，挂上时初始属性原样不动；一律向下取整）。
    // ⚠️ 负面特性**不复用**事件侧那三张负面标签（炒作狗/玻璃美人/戏痴，pool 缺省＝局内被动获得）——
    //   那三张是事件给的，开局池再放同一张会造成同一标签两头拿。
    // ✅ TAG_401 黑料缠身（2026-10-23 实装）：开局 口碑 −200 ＋ 此后每次**负向口碑** ×1.5。
    //   原稿「负面事件失败分支 ×1.1」实测读不出来（−2/−3 的 1.1 倍取整回原值）⇒ 用户改判 ×1.5，
    //   且放大口径扩到「所有负向口碑」（作品低分/事件失败/黑帖数值事件一起算），门槛不变。
    {
        id: 'TAG_401',
        name: '黑料缠身',
        type: 'negative',
        description: '出道前那点旧事被人翻出来挂在热搜上，怎么解释都像在解释',
        acquireCondition: '开局特性选择',
        priority: 100,
        pool: 'trait',
        /** 负数＝返还点数 */
        traitPoints: -2,
        /** 开局一次性口碑 −200（落在黑红路线 T1 深档，代价换 2 点预算） */
        startReputationPenalty: -200,
        /** 此后每一次负向口碑 ×1.5（正向不乘） */
        reputationLossMult: 1.5,
        perk: '开局口碑 -200 · 此后每次口碑损失 ×1.5',
    },
    {
        id: 'TAG_402',
        name: '九漏鱼',
        type: 'negative',
        description: '九年义务教育漏网之鱼',
        /** 该属性：训练获得的增量减半 */
        halvedAttr: 'wisdom',
        acquireCondition: '开局特性选择',
        priority: 100,
        pool: 'trait',
        /** 负数＝返还点数 */
        traitPoints: -1,
        perk: '训练获得的智慧减半',
    },
    {
        id: 'TAG_403',
        name: '五音不全',
        type: 'negative',
        description: '唱一句跑三个调，练一晚上还在原地',
        halvedAttr: 'artistry',
        acquireCondition: '开局特性选择',
        priority: 100,
        pool: 'trait',
        traitPoints: -1,
        perk: '训练获得的才艺减半',
    },
    {
        id: 'TAG_404',
        name: '低情商',
        type: 'negative',
        description: '你把每句场面话都当真了，没人往下说',
        halvedAttr: 'eq',
        acquireCondition: '开局特性选择',
        priority: 100,
        pool: 'trait',
        traitPoints: -1,
        perk: '训练获得的情商减半',
    },
    {
        id: 'TAG_405',
        name: '无效营销',
        type: 'negative',
        description: '做多少营销，都是白费力气',
        acquireCondition: '开局特性选择',
        priority: 100,
        pool: 'trait',
        /** 负数＝返还点数 */
        traitPoints: -1,
        /**
         * **营销渠道**产出的名气 ×本值。
         * ⚠️ 渠道口径是**可扩展的**（2026-10-21 用户令「后面会加别的营销渠道，不只是发微博」）：
         *   凡"靠经营/曝光换来的名气"都算营销渠道，一律经 `GameState.marketingFameGain` 过一道。
         *   现存渠道＝微博营业帖（整笔）／剧宣帖的「自营业」那半／公益帖（整笔）；
         *   **将来加新渠道时，在新渠道的 fame 发放处调 `state.marketingFameGain(x)` 即可**，
         *   ⛔ 别绕过它自己乘。
         * ⛔ 不算营销：作品本身给的名气（杀青滴灌、剧宣帖的作品分红）、奖项、事件/行程。
         * ✅ **倍率 ×0.8 定稿**（2026-10-22 用户令「倍率 0.8」）。
         *   读数提醒：营销这条路的名气在全局里占比很小（作品 78／事件行程 21／奖项 1，§3.4q）⇒ 很轻。
         */
        marketingFameMult: 0.8,
        perk: '各类营销获得的名气 ×0.8',
    },

    // ===== 负面标签 =====
    {
        id: 'TAG_101',
        name: '耍大牌',
        type: 'negative',
        description: '传闻你在片场耍大牌，合作方多有微词',
        attributeBonus: { reputation: -5, eq: -3 },
        acquireCondition: '多次拒绝工作或负面事件积累',
        removeCondition: '连续3个月正面行为',
        priority: 50,
        perk: '口碑 -5 · 情商 -3',
    },
    {
        id: 'TAG_102',
        name: '票房毒药',
        type: 'negative',
        description: '你参演的作品票房表现不佳',
        attributeBonus: { reputation: -3, eq: -2 },
        acquireCondition: '连续多部作品失败',
        removeCondition: '参演一部成功作品',
        priority: 50,
        perk: '口碑 -3 · 情商 -2',
    },
    {
        id: 'TAG_103',
        name: '花瓶',
        type: 'negative',
        description: '观众认为你只有外表没有实力',
        attributeBonus: { talent: -5, reputation: -3 },
        acquireCondition: '颜值远高于演技时触发',
        removeCondition: '演技达到一定水平',
        priority: 60,
        perk: '演技 -5 · 口碑 -3',
    },

    // ===== 中性标签 =====
    {
        id: 'TAG_201',
        name: '跨界艺人',
        type: 'neutral',
        description: '你不局限于单一领域，经常跨界尝试',
        attributeBonus: { reputation: 5 },
        acquireCondition: '参与3种以上不同类型的通告',
        priority: 40,
        perk: '口碑 +5',
    },
    {
        id: 'TAG_202',
        name: '话题女王',
        type: 'neutral',
        description: '你总是能成为媒体关注的焦点',
        attributeBonus: { reputation: 8, eq: -1 },
        acquireCondition: '多次成为舆论中心',
        priority: 50,
        perk: '口碑 +8 · 情商 -1',
    },
    {
        id: 'TAG_203',
        name: '劳模',
        type: 'neutral',
        description: '你以勤奋敬业著称',
        attributeBonus: { stamina: 3, reputation: 2 },
        acquireCondition: '连续多月高强度工作',
        priority: 60,
        perk: '体能 +3 · 口碑 +2',
    },

    // ===== 奖项标签（TAG_3xx 号段，年度奖项批）=====
    // 永久荣誉标签：无 removeCondition、无 attributeBonus（加成另批定标，本批刻意留空防数值失衡）
    {
        id: 'TAG_301',
        name: '金枢影帝',
        type: 'positive',
        description: '金枢奖最佳男主角，演技派的顶点',
        acquireCondition: '金枢奖最佳男主角获奖',
        priority: 95,
        perk: '永久荣誉',
    },
    {
        id: 'TAG_302',
        name: '金枢影后',
        type: 'positive',
        description: '金枢奖最佳女主角，大银幕的最高认可',
        acquireCondition: '金枢奖最佳女主角获奖',
        priority: 95,
        perk: '永久荣誉',
    },
    {
        id: 'TAG_303',
        name: '金枢最佳男配',
        type: 'positive',
        description: '金枢奖最佳男配角',
        acquireCondition: '金枢奖最佳男配角获奖',
        priority: 90,
        perk: '永久荣誉',
    },
    {
        id: 'TAG_304',
        name: '金枢最佳女配',
        type: 'positive',
        description: '金枢奖最佳女配角',
        acquireCondition: '金枢奖最佳女配角获奖',
        priority: 90,
        perk: '永久荣誉',
    },
    {
        id: 'TAG_305',
        name: '星汉视帝',
        type: 'positive',
        description: '星汉奖最佳男主角，小荧屏的扛鼎之人',
        acquireCondition: '星汉奖最佳男主角获奖',
        priority: 95,
        perk: '永久荣誉',
    },
    {
        id: 'TAG_306',
        name: '星汉视后',
        type: 'positive',
        description: '星汉奖最佳女主角，剧集收视与口碑的双保险',
        acquireCondition: '星汉奖最佳女主角获奖',
        priority: 95,
        perk: '永久荣誉',
    },
    {
        id: 'TAG_307',
        name: '星汉最佳男配',
        type: 'positive',
        description: '星汉奖最佳男配角',
        acquireCondition: '星汉奖最佳男配角获奖',
        priority: 90,
        perk: '永久荣誉',
    },
    {
        id: 'TAG_308',
        name: '星汉最佳女配',
        type: 'positive',
        description: '星汉奖最佳女配角',
        acquireCondition: '星汉奖最佳女配角获奖',
        priority: 90,
        perk: '永久荣誉',
    },

    // ===== 能力 tag（TAG_SKILL_* 号段，特训重做批 2026-10-30）=====
    // 纯资格标记：无 attributeBonus、无 traitPoints——作用是解锁带 requiredTag 的角色试镜资格
    // （ScriptRoleDef.requiredTag，消费端首批=综艺主持类角色）。唯一获取途径=对应特训累计 10 次
    // （ScheduleSystem.settleSpecialTraining）；不可解除——能力练成是一辈子的，无解除入口是设计非遗漏。
    {
        id: 'TAG_SKILL_HOST',
        name: '主持能力',
        type: 'positive',
        description: '话筒前接得住任何场面的本事，一期期特训练出来的硬功夫',
        acquireCondition: '主持特训累计 10 次',
        priority: 90,
        pool: 'event',
        perk: '能接住任何场面的话筒',
    },
    {
        id: 'TAG_SKILL_SINGDANCE',
        name: '唱跳能力',
        type: 'positive',
        description: '边唱边跳气都不乱，舞台上站得住的真底子',
        acquireCondition: '唱跳特训累计 10 次',
        priority: 90,
        pool: 'event',
        perk: '舞台上能唱会跳的底气',
    },
    {
        id: 'TAG_SKILL_MARTIAL',
        name: '武打能力',
        type: 'positive',
        description: '招式受身都进了身体，动作戏不用替身的硬资本',
        acquireCondition: '武术特训累计 10 次',
        priority: 90,
        pool: 'event',
        perk: '动作戏亲自上阵的资本',
    },
];

/** 按 ID 索引 */
export const TAG_MAP: Record<string, TagDef> = {};
TAGS.forEach(t => { TAG_MAP[t.id] = t; });

/** 默认/当前唯一开放身份：素人出道（2026-10-19 开局身份拆分） */
export const ORIGIN_ORDINARY = 'TAG_014';

/** 身份拆分前的老标签：旧档迁移时反推 origin 并从 tags 摘除 */
export const LEGACY_ORIGIN_TAGS = ['TAG_001', 'TAG_012', 'TAG_013'] as const;